import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgHover = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 32, height: 32, viewBox: "0 0 32 32", role: "img", ref, ...props, children: /* @__PURE__ */ jsxs("g", { fill: "none", children: [
  /* @__PURE__ */ jsx("g", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, children: /* @__PURE__ */ jsx("path", { d: "M8 8l6.67 16L17 17l7-2.33zM17.42 17.42l5.64 5.64" }) }),
  /* @__PURE__ */ jsx("path", { d: "M0 0h32v32H0z" })
] }) });
const ForwardRef = forwardRef(SvgHover);
export default ForwardRef;
